import React from 'react';
import { UploadCloud, X } from 'lucide-react';

const FileUploadProgress = ({ progress, fileName, onCancel }) => {
    return (
        <div className="fixed bottom-4 right-4 bg-white rounded-xl shadow-2xl p-4 w-80 border border-slate-100 z-50 animate-in slide-in-from-bottom-5 duration-300">
            <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
                    <UploadCloud size={20} />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-bold text-slate-800 truncate">Uploading {fileName || 'file...'}</p>
                    <p className="text-xs text-slate-500">{Math.round(progress)}% complete</p>
                </div>
                {onCancel && (
                    <button onClick={onCancel} className="p-1 text-slate-400 hover:text-red-500 rounded-full">
                        <X size={16} />
                    </button>
                )}
            </div>
            <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div
                    className="h-full bg-blue-500 rounded-full transition-all duration-300 ease-out"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>
        </div>
    );
};

export default FileUploadProgress;
